import { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/esm/Modal";
import { Helmet } from "react-helmet-async";
import PhoneInput from "react-phone-input-2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import LoadingBox from "../components/LoadingBox";
import useAxios from "../hooks/useAxios";
import { getError, loginHandler } from "../utils";

export default function CustomerChangePassword() {
  const Axios = useAxios();
  const navigate = useNavigate();
  const { search } = useLocation();
  const redirectInUrl = new URLSearchParams(search).get("redirect");
  const redirect = redirectInUrl ? redirectInUrl : "/";

  const [showOtpValidation, setShowOtpValidation] = useState(false);
  const [otpValidated, setOtpValidated] = useState(false);
  const [phoneAlreadyInUse, setPhoneAlreadyInUse] = useState(false);
  const [otpValidatingStatus, setOtpValidatingStatus] = useState(false);
  const [customerOtp, setCustomerOtp] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [formValidated, setFormValidated] = useState(false);
  const [phoneValid, setPhoneValid] = useState(true);

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  const submitHandler = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setFormValidated(true);

      if (phone.length !== 12) {
        setPhoneValid(false);
      }
      return;
    }

    if (phone.length !== 12) {
      setPhoneValid(false);
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Şifre tekrarı hatalı");
      return;
    }

    if (password.length < 6) {
      toast.error("Şifre en az alti karakter olmalidir.");
      return;
    }

    try {
      const { data } = await Axios.get(`/api/users/checkphone/${"+" + phone}`);
      if (!data.phoneInUse) {
        toast.error("Girdiğiniz telefon numarasına ait bir hesap bulunamadi.");
        return;
      }
    } catch (err) {
      return;
    }

    if (!otpValidated) {
      try {
        await Axios.post("/otp/send", {
          phoneNumber: "+" + phone,
        });
        setShowOtpValidation(true);
      } catch (err) {
        toast.error("Doğrulama SMS'i gönderilemedi");
        return;
      }
      return;
    }
  };

  const handleKayitFinish = async () => {
    try {
      const { data } = await Axios.put(`/api/users/changepass/${"+" + phone}`, {
        password,
      });
      loginHandler(data, ctxDispatch, localStorage);
      navigate(redirect || "/");
    } catch (err) {
      toast.error(getError(err));
    }
  };

  const handleValidateOtp = async (kod) => {
    try {
      const { data } = await Axios.post("/otp/check", {
        to: "+" + phone,
        code: kod,
      });

      if (data.status) {
        setShowOtpValidation(false);
        handleKayitFinish();
      } else {
        toast.error("Doğrulama kodu hatalı, lütfen tekrar deneyiniz.");
      }
      setOtpValidatingStatus(false);
    } catch (err) {
      setOtpValidatingStatus(false);
      toast.error("Doğrulama kodu hatalı, lütfen tekrar deneyiniz.");
    }
  };

  useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }
  }, [navigate, redirect, userInfo]);

  return (
    <Container className="small-container">
      <Helmet>
        <title>Kullanıcı Kaydı</title>
      </Helmet>
      <h1 className="my-3">Kullanıcı Kaydı</h1>
      <Form onSubmit={submitHandler} noValidate validated={formValidated}>
        <Form.Group className="mb-3">
          <Form.Label>Telefon Numaranız</Form.Label>
          <PhoneInput
            country={"tr"}
            onlyCountries={["tr"]}
            countryCodeEditable={false}
            value={phone}
            onChange={(p) => {
              setPhone(p);
              setPhoneValid(true);
              setPhoneAlreadyInUse(false);
            }}
            inputStyle={{ width: "100%" }}
            inputProps={{
              name: "Telefon",
            }}
            isValid={(value, country) => {
              if (!phoneValid) {
                return "Telefon numarasını hatalı girdiniz";
              }
            }}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Yeni Şifre</Form.Label>
          <Form.Control
            type="password"
            required
            onChange={(e) => setPassword(e.target.value)}
          />
          <small id="passwordHelpBlock" className="form-text text-muted">
            Şifre en az altı karakter olmalıdır
          </small>
          <Form.Control.Feedback type="invalid">
            Lutfen şifre alanini bos birakmayiniz
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Yeni Şifrenizi Tekrar Ediniz</Form.Label>
          <Form.Control
            type="password"
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <Form.Control.Feedback type="invalid">
            Lutfen şifre alanini bos birakmayiniz
          </Form.Control.Feedback>
        </Form.Group>
        <div className="mb-3">
          <Button type="submit">Şifremi Değiştir</Button>
        </div>
        <div className="mb-3">
          Şifremi hatırlıyor musunuz?{" "}
          <Link to={`/customer_signin?redirect=${redirect}`}>Giriş Yap</Link>
        </div>
      </Form>

      <Modal
        show={showOtpValidation}
        onHide={() => setShowOtpValidation(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>E-posta Doğrulama Kodu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label className="text-danger text-muted">
              E-posta doğrulama kodunu giriniz!
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                setCustomerOtp(e.target.value);
                if (e.target.value.length === 4) {
                  setOtpValidatingStatus(true);
                  handleValidateOtp(e.target.value);
                }
              }}
              type="number"
              autoFocus
            />
            {otpValidatingStatus && (
              <LoadingBox>Doğrulama yapıliyor</LoadingBox>
            )}
            <Form.Control.Feedback type="invalid">
              Lütfen ad alanını boş bırakmayınız
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </Container>
  );
}
